var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('v-alert',{staticClass:"mb-0",attrs:{"border":"bottom","type":"error","colored-border":"","elevation":"4"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }